import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fetchSymbolEnsemble } from "../api/client";

export function EnsemblePage() {
  const [symbol, setSymbol] = useState("NVDA");
  const [submitted, setSubmitted] = useState("NVDA");

  const { data, isLoading, error } = useQuery({
    queryKey: ["ensemble", submitted],
    queryFn: () => fetchSymbolEnsemble(submitted, 200),
    enabled: !!submitted,
  });

  const series = (data?.points ?? []).slice().reverse(); // ascending time for chart

  return (
    <div>
      <form
        className="toolbar"
        onSubmit={(e) => { e.preventDefault(); setSubmitted(symbol.toUpperCase()); }}
      >
        <input
          placeholder="Symbol (e.g. NVDA)"
          value={symbol}
          onChange={(e) => setSymbol(e.target.value.toUpperCase())}
        />
        <button type="submit">Load</button>
        <span style={{ color: "#94a3b8", fontSize: 13 }}>
          {isLoading ? "loading…" : data ? `${data.count} decisions` : ""}
        </span>
      </form>

      {error && <div className="card" style={{ color: "#fca5a5" }}>{String(error)}</div>}

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Ensemble disagreement (std dev of contributing model actions)</h3>
        {series.length > 0 ? (
          <ResponsiveContainer width="100%" height={260}>
            <LineChart data={series}>
              <CartesianGrid stroke="#1e293b" strokeDasharray="3 3" />
              <XAxis dataKey="decision_ts" tick={{ fill: "#94a3b8", fontSize: 11 }} hide />
              <YAxis tick={{ fill: "#94a3b8", fontSize: 11 }} />
              <Tooltip
                contentStyle={{ background: "#0b1220", border: "1px solid #1e293b" }}
                labelFormatter={(l) => String(l)}
              />
              <Line type="monotone" dataKey="std_dev" stroke="#f59e0b" dot={false} strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div style={{ color: "#94a3b8" }}>No data for this symbol yet.</div>
        )}
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Recent decisions</h3>
        <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th className="num">Ensemble action</th>
              <th className="num">Std dev</th>
              <th className="num">Confidence</th>
              <th className="num">Contributors</th>
              <th>Per-model actions</th>
            </tr>
          </thead>
          <tbody>
            {(data?.points ?? []).map((p) => (
              <tr key={p.decision_ts}>
                <td style={{ fontSize: 12 }}>
                  <Link to={`/replay/${encodeURIComponent(submitted)}/${encodeURIComponent(p.decision_ts)}`}>
                    {p.decision_ts}
                  </Link>
                </td>
                <td className="num">{Number(p.ensemble_action).toFixed(4)}</td>
                <td className="num">{Number(p.std_dev).toFixed(4)}</td>
                <td className="num">{Number(p.confidence).toFixed(3)}</td>
                <td className="num">{p.num_contributors}</td>
                <td style={{ fontSize: 12, color: "#94a3b8" }}>
                  {p.contributors.map((c) => `${c.model_id.slice(0, 16)}…: ${c.individual_action.toFixed(3)}`).join("  |  ")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
